// extracted by mini-css-extract-plugin
module.exports = {"heading":"voucher-column_heading__3Tw3n"};